<style lang="stylus" scoped>
@import '../css/var'
.img-container
  display flex
  justify-content space-between
  align-items center
  height pt(130)
  background #090A0A
  opacity 0.8

.image
  margin-left pt(30)
  width  pt(60)
  margin-right pt(15)

.title
  flex-grow 1

.company-name
  color #A0A1A3
  margin-bottom pt(5)

.tip-color
  color #A0A1A3

.qrcode
  width pt(110)
  height pt(110)
  margin-right pt(20)

.close-btn
  color #30C37E
  margin-right pt(20)

</style>
<template>
  <div>
    <div class="img-container">
     <img class="qrcode" :src="qrcode"></img>
      <div class="title">
        <div class="company-name">关注智慧食堂</div>
        <div class="tip-color">长按左边二维码</div>
      </div>
      <div class="close-btn"  @click="click">关闭</div>
  </div>
  </div>
</template>
<script>
import qrcode from '../assets/img/qrcode.jpg'
export default {
  data () {
    return {
      qrcode: qrcode
    }
  },
  methods: {
    increment (value) {
      this.$emit('click', value)
    },
    click () {
      this.increment('qrcode-tip')
    }
  }
}
</script>


// WEBPACK FOOTER //
// qrcode-tip.vue?19324aeb